import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PolicyModel } from "@models/configuration/policy.model";
import { Store } from "@ngrx/store";
import * as fromAppRoot from "@reducers/index";
import { PolicyActions } from "@actions/configuration/index";
import { TableStorageActionModel } from "@models/common/table-storage-action.model";
import { Partitions } from "@root/core/enums/partition.enum";
import { FacadeInterface } from "@interfaces/facade-interface";

@Injectable({
  providedIn: "root",
})
export class PolicyFacadeService implements FacadeInterface<PolicyModel> {
  getAll$(): Observable<PolicyModel[]> {
    return this.store.select(fromAppRoot.getPolicies);
  }

  getCurrentItem$(): Observable<PolicyModel> {
    return this.store.select(fromAppRoot.getCurrentPolicy);
  }

  search(): void {
    const props: TableStorageActionModel<PolicyModel> = {
      queryParams: `${Partitions.POLICY}/GetwsSignPolicies`,
    };
    this.store.dispatch(PolicyActions.searchPolicies({ action: props }));
  }

  create(payload: PolicyModel): void {
    const props: TableStorageActionModel<PolicyModel> = {
      queryParams: `${Partitions.POLICY}/Post`,
      payload,
    };
    this.store.dispatch(PolicyActions.createPolicy({ action: props }));
  }

  update(payload: PolicyModel): void {
    const action: TableStorageActionModel<PolicyModel> = {
      queryParams: `${Partitions.POLICY}/Post`,
      payload,
    };
    this.store.dispatch(PolicyActions.updatePolicy({ action }));
  }

  setCurrentItem(rowKey: string): void {
    this.store.dispatch(PolicyActions.setCurrentPolicy({ rowKey }));
  }

  select(Policy: PolicyModel): void {
    this.store.dispatch(PolicyActions.selectPolicy({ Policy }));
  }

  delete(payload: PolicyModel): void {
    const props: TableStorageActionModel<PolicyModel> = {
      queryParams: `${Partitions.POLICY}/Delete?id=` + payload.id,
      payload,
    };
    this.store.dispatch(PolicyActions.deletePolicy({ action: props }));
  }

  reset(): void {}

  resetSelected(): void {}

  getIsLoading$(): Observable<boolean> {
    return this.store.select(fromAppRoot.getLoadingPolicy);
  }

  constructor(private store: Store<fromAppRoot.State>) {}
}
